import { useSiteSettings } from '@/src/context/SiteSettingsContext';
import { IDefaultPreOwnedCampaign } from '../../types';

export const calcCampaignPreOwnedPrice = (
  campaign: IDefaultPreOwnedCampaign | undefined,
  price: number
): number => {
  const { slug } = useSiteSettings();

  if (
    !campaign ||
    !campaign.content.reduction ||
    !campaign.content.reductionType
  ) {
    return price;
  }

  let campaignReduction = parseFloat(
    campaign.content.reduction.replace(/[^0-9.-]+/g, '')
  );

  if (campaign.content.reductionType === 'amount' && slug === '/us') {
    campaignReduction = parseFloat(
      campaign.content.reduction_amount_USD?.replace(/[^0-9.-]+/g, '') || '0'
    );
  }

  if (isNaN(campaignReduction) || campaignReduction <= 0) {
    return price;
  }

  if (campaign.content.reductionType === 'percent') {
    return price * (1 - campaignReduction / 100);
  } else if (campaign.content.reductionType === 'amount') {
    return Math.max(0, price - campaignReduction);
  }

  return price;
};
